import {create} from 'zustand/react';
import type {MessageInfo} from '../pages/message/types';

type TCurrentPage = 'list' | 'detail';

interface IMessageStore {
    currentPage: TCurrentPage;
    setCurrentPage: (val: TCurrentPage) => void;
    selectedMessage: MessageInfo | null;
    setSelectedMessage: (val: MessageInfo | null) => void;
}

const useMessageStore = create<IMessageStore>((set, get) => ({
    currentPage: 'list',
    setCurrentPage: (val: TCurrentPage) => {
        set({currentPage: val});
    },
    selectedMessage: null,
    setSelectedMessage: (val: MessageInfo | null) => {
        set({selectedMessage: val});
    },
}));

export default useMessageStore;
